import en from "date-fns/locale/en-US";
import ko from "date-fns/locale/ko";
import React, { useEffect, useState } from "react";
import { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useTranslation } from "react-i18next";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Input,
  Row,
  Spinner,
} from "reactstrap";
import {
  CONFIG_OPTION_TOAST_ERROR,
  CONFIG_OPTION_TOAST_NORMAL,
} from "common/toast";
import { getTimeWorkingList, postTimeWorking, putTimeWorking } from "store/time-working/thunk";
import { LIST_OPTION_BAR_DETAIL_WORKING_TIME_DAYS } from "helpers/constans";
import * as Yup from "yup";
import {
  useFormik,
} from "formik";
import DropdownHours from "components/Common/DropdownHours";

export interface Tag {
  id: string;
  text: string;
}

registerLocale("en", en);
registerLocale("ko", ko);

export interface ISearch {
  page: number;
  limit: number;
  keyword: string;
}

export interface IWorkShift {
  id?: string;
  bar_id?: string;
  dow: string;
  work_in: string;
  work_out: string;
  status: number;
  note: string;
}

export interface IProps {
  barID?: any;
  isShowDetail?: boolean;
}

const TimeWorkingList = ({ barID, isShowDetail }: IProps) => {
  const { t, i18n } = useTranslation();

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [dataTimeWorking, setDataTimeWorking] = useState<any>([])

  const validationSchema = Yup.object({
    // bar_id: Yup.string().required(`${t("This field is required")}`),
    // user_id: Yup.string().required(`${t("This field is required")}`),
  });

  const initWorkShifts = LIST_OPTION_BAR_DETAIL_WORKING_TIME_DAYS.map((item) => (
    {
      dow: item?.value,
      work_in: "",
      work_out: "",
      status: 1,
      note: "",
      // id: ""
    }
  ))

  const getTimeWorkingApi = async (id: string) => {
    const res: any = await getTimeWorkingList({
      bar_id: id
    })

    if(res?.code === 200) {
      if(res?.data?.length > 0) {
        setDataTimeWorking(res?.data);
        const formatDayOfWeek = res?.data?.sort((a: any, b: any) => parseInt(a?.dow) - parseInt(b?.dow));
        formik.setFieldValue('workshifts', formatDayOfWeek);
      }else {
        formik.setFieldValue('workshifts', initWorkShifts);
      }
    }
  }
  
  const handleSubmit = async (values: any) => {
    try {
      if(!barID) return;
      setIsLoading((_prev) => true);

      const data = {
        bar_id: barID,
        ...values
      };

      const response: any = dataTimeWorking?.length > 0 ? await putTimeWorking(data) : await postTimeWorking(data);
      if (response?.code === 200) {
        setIsLoading((_prev) => false);
        getTimeWorkingApi(barID);
        toast(
          `${t("The process has been completed.")}`,
          CONFIG_OPTION_TOAST_NORMAL
        );
      } else {
        setIsLoading((_prev) => false);
        toast(`${response}`, CONFIG_OPTION_TOAST_ERROR);
      }
    } catch (error: any) {
      setIsLoading((_prev) => false);
      toast(`${error?.message || ""}`, CONFIG_OPTION_TOAST_ERROR);
      return error;
    }
  };

  const initialValues: IWorkShift[] = [];

  const formik = useFormik({
    initialValues: {
      workshifts: initialValues
    },
    validationSchema,
    onSubmit: handleSubmit,
  });

  useEffect(() => {
    if(barID) {
      getTimeWorkingApi(barID);
    }

  }, [barID])

  useEffect(() => {
    document.title = `${t("Time Working")} - ${t("Bar Detail")} | Baive`;
    document.body.classList.remove("vertical-sidebar-enable");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [i18n?.language]);

  return (
    <React.Fragment>
      <div className="mt-3">
        <Container fluid>
          <Row>
            <Col lg={12}>
              <Card
                id="customerList"
                style={{ boxShadow: "0px 3px 4px 0px rgba(0, 0, 0, 0.03)" }}
              >
                <CardHeader className="border-0">
                  <Row className="g-4 align-items-center">
                    <div className="col-sm">
                      <div>
                        <h5 className="card-title mb-0">{t('Day of week')}</h5>
                      </div>
                    </div>
                  </Row>
                </CardHeader>

                <CardBody className="pt-3">
                  <div>
                    <form onSubmit={formik.handleSubmit}>
                      {formik?.values?.workshifts?.map(
                        (item: any, index) => {
                          return (
                            <Row className=" d-flex align-items-center" key={index}>
                              <Col xxl={1}>
                                <div className="fw-semibold">
                                  {
                                    t(LIST_OPTION_BAR_DETAIL_WORKING_TIME_DAYS?.find((day: any) => day?.value == item?.dow)?.label || '')
                                  }
                                </div>

                                <input
                                  type="hidden"
                                  className="form-check-input"
                                  name={`${item?.value}.dow`}
                                  value={
                                    formik?.values?.workshifts?.[index]?.dow
                                  }
                                  onChange={(e) => {
                                    const value = e?.target?.checked;
                                    formik.setFieldValue(
                                      `workshifts.${index}.dow`,
                                      !!value
                                    );
                                  }}
                                />
                              </Col>

                              <Col
                                xxl={1}
                                className="date-picker-wrapper-custom mt-3 mt-md-2"
                                style={{maxWidth: "115px"}}
                              >
                                <div className="mb-3">
                                  <div
                                    className="form-check form-switch form-switch-sm text-center d-flex"
                                    dir="ltr"
                                  >
                                    <input
                                      type="checkbox"
                                      className="form-check-input"
                                      name={`workshifts.${index}.status`}
                                      checked={
                                        !!formik?.values?.workshifts?.[index]
                                          ?.status
                                      }
                                      onChange={(e) => {
                                        const value = e?.target?.checked;
                                        formik.setFieldValue(
                                          `workshifts.${index}.status`,
                                          !!value
                                        );
                                      }}
                                    />
                                    <span className="px-2">
                                      {formik?.values?.workshifts?.[index]
                                        ?.status
                                        ? t(`Open`)
                                        : t(`Closed`)}
                                    </span>
                                  </div>
                                </div>
                              </Col>

                              <Col
                                xxl={3}
                                className="date-picker-wrapper-custom mt-3 mt-md-2 "
                                style={{maxWidth: "380px"}}
                              >
                                <Row className="mb-3 d-flex align-items-center justify-content-center" style={{maxWidth: "380px"}}>
                                  <Col xxl={5}>
                                    <DropdownHours
                                      name="work_in"
                                      initialValue={formik?.values?.workshifts?.[index]?.work_in || ''}
                                      onChangeSelect={(value: any) => {
                                        formik.setFieldValue(
                                          `workshifts.${index}.work_in`,
                                          value?.value
                                        );
                                      }}
                                    />
                                  </Col>
                                  <Col xxl={2}  style={{paddingLeft: "0", paddingRight: "0", textAlign: "center", maxWidth: "15px"}}>
                                      <span>-</span>
                                  </Col>
                                  <Col xxl={5}>
                                    <DropdownHours
                                      name="work_out"
                                      initialValue={formik?.values?.workshifts?.[index]?.work_out}
                                      onChangeSelect={(value: any) => {
                                        formik.setFieldValue(
                                          `workshifts.${index}.work_out`,
                                          value?.value
                                        );
                                      }}
                                    />
                                  </Col>
                                </Row>
                              </Col>

                              <Col
                                xxl={7}
                                className="date-picker-wrapper-custom mt-2 mt-md-2"
                              >
                                <div className="mb-3">

                                  <Input
                                    type="text"
                                    className="form-control"
                                    name={`workshifts.${index}.note`}
                                    placeholder={t("Note")}
                                    value={
                                      formik?.values?.workshifts?.[index]?.note
                                    }
                                    onChange={(event: any) =>
                                      formik.setFieldValue(
                                        `workshifts.${index}.note`,
                                        event?.target?.value || ""
                                      )
                                    }
                                  />
                                </div>
                              </Col>
                            </Row>
                          );
                        }
                      )}

                      {!isShowDetail && (
                        <Row>
                          <Col lg={12}>
                            <div className="hstack gap-2 justify-content-end mt-2">
                              <button
                                className="btn btn-primary fs-14"
                                color="success"
                                type="submit"
                                disabled={isLoading}
                                style={{ width: "140px" }}
                              >
                                {isLoading ? (
                                  <Spinner size="sm" className="me-2"></Spinner>
                                ) : (
                                  <>{t("Apply")}</>
                                )}
                              </button>
                            </div>
                          </Col>
                        </Row>
                      )}
                    </form>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default TimeWorkingList;
